<template>
</template>

<script>
export default {
    data: function () {
        return {
            method: 'free',
            freeForm: {
                stripe_new_saved: 'new',
                bundle: this.bundle,
                product: this.product,
                name: '',
                email: '',
                terms: '',
                marketing: 0,
                method: '',
            },
            disableOnSubmit: false,
            paymentStatus: 'processing',
            errorCode: false,
            errorMessage: false,
            stripePaymentRequestCount: 0,
            elements: null,
            stripeNewSaved: 'new',
            formName: '',
            copiedStatus: false,
            selectedPrice: this.price,
            bundleLookup: this.bundleHashid ? this.bundleHashid : false,
        }
    },
    props: [
        'auth',
        'hasVoucher',
        'buyUrl',
        'env',
        'product',
        'bundle',
        'price',
        'bundleHashid',
    ],
    computed: {

    },
    mounted() {

    },
    watch: {
        'freeForm.terms'(value) {
            if (value == true) {
                this.disableOnSubmit = false;
            } else {
                this.disableOnSubmit = true;
            }
        },
    },

    methods: {
        modifyForm() {
            this.freeForm.method = 'free';
            this.freeForm.bundle_hashid = this.bundleLookup;
            return this.freeForm;
        },

        copyName () {
            this.stripeForm.card_name = this.stripeForm.name;
            this.copiedStatus = true;
        },

        submitFreePayment() {
            $('#processing-modal-buy-report').modal({backdrop: 'static', keyboard: false});
            
            let self = this;

            self.disableOnSubmit = true;

            this.$validator.validateAll('freeForm').then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    $('#processing-modal').modal({backdrop: 'static', keyboard: false});
                    this.sendFreePaymentData();
                } else {
                   // self.disableOnSubmit = false;
                }
            });
        },

        sendFreePaymentData() {
            this.stripePaymentRequestCount++;

            // Only send call buy-report once. Fix to double click/double post issue.
            if (this.stripePaymentRequestCount < 2) {
                let postData = this.modifyForm();

                axios
                .post(this.buyUrl, postData)
                .then(response => {
                    window.location = response.data.redirectUrl;
                })
                .catch(error => {
                    this.stripePaymentRequestCount = 0;
                    this.handleError(error.response.data);
                });
            }
        },

        validationClass(hasErrors) {
            return this.$parent.validationClass(hasErrors);
        },

        handleError(response) {
            let errorCode, message;

            if (typeof response.error == 'object') {
                response = response.error;
            }

            message = response.message;

            switch (message) {
                case 'Validation failed':
                    this.$parent.paymentStatus = 'error-general';
                    this.$parent.errorCode = '00422';
                    break;
                case 'Server Error':
                    this.$parent.paymentStatus = 'error-general';
                    this.$parent.errorCode = '00501';
                    break;
                case 'There has been a server error trying to complete your request. If this error persists please contact support to report the issue.':
                    this.$parent.paymentStatus = 'error-general';
                    this.$parent.errorCode = '00500';
                    break;
                case 'response_exception':
                    this.$parent.paymentStatus = 'error-general';
                    this.$parent.errorCode = '00588';
                    break;
                default:
                    this.$parent.paymentStatus = 'error-general';
                    this.$parent.errorCode = '00599';
            }
        },

        closeModal () {
            this.disableOnSubmit = false;
            $('#processing-modal-stripe-pay').modal('hide');
            this.paymentStatus = 'processing';
        },

        closeModalRedirectToContact () {
            $('#processing-modal-stripe-pay').modal('hide');
            window.location = '/contact';
        },
    },
    components: {

    }
}
</script>
